import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MagneticDirective } from '../../directives/magnetic.directive';

@Component({
  selector: 'app-button',
  imports: [],
  hostDirectives: [MagneticDirective],
  templateUrl: './button.html',
  styleUrl: './button.scss'
})
export class Button {

  @Input()
  public buttonText = '';

  @Output()
  private clicked = new EventEmitter<void>();

  click() {
    this.clicked.emit();
  }

}
